import { null_, object } from "valibot";

import { rpcContract } from "../rpc";

export const signOutRpcContract = rpcContract({
  name: "sign-out",
  paramsSchema: null_(),
  resultSchema: object({}),
});
